import React from 'react';
import { text } from '../data';
import { GHLink } from '../types/types';

interface AdditionalHelpProps {
	links: Array<GHLink>;
}

const AdditionalHelp: React.FC<AdditionalHelpProps> = ( { links } ) => {
	return (
		<div className="c-guided-help__additional-help">
			<h4>{text.additionalHelp}</h4>
			{links.map( ( link ) => {
				const { id, icon, label, url } = link;

				return (
					<div key={id} className="c-guided-help__icon-link">
						<span className={`icon ${ icon }`}></span>
						<a href={url} data-link-click>
							{label}
						</a>
					</div>
				);
			} )}
		</div>
	);
};

export default AdditionalHelp;
